import { Injectable } from '@angular/core';
import { ServiceRepository } from '../service-repository'
import { HttpParams, HttpErrorResponse } from "@angular/common/http";
import { Offline,FileDownloadpath } from '../../Model/offline/offline.model';
import { Observable, throwError } from 'rxjs';
import { map, filter, catchError, mergeMap } from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class OfflineService {
  constructor(
    private _repositoryService: ServiceRepository
  ) { }

 


  getOfflineReportonUserProject(userId: string, projectId: string): Observable<Offline[]> {
    let params = new HttpParams();
   
    return this._repositoryService.getAll<Offline[]>(  
    '/api/Offline/GetOfflineReport/' + userId +"/" + projectId ,params)
      .pipe(
        map(data => data.map(data => new Offline().deserialize(data))),
        catchError( error => {
          return throwError( error );
        })
      )
  }

  getFile(filepath: FileDownloadpath){
    return this._repositoryService
    .downloadfile('/api/ContactUs/DownloadFile', filepath)   
    
  }



  errorHandler(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
     
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }


}
